<template>
  <FormulateInput
    class="p-0"
    v-bind="field"
    validation-behavior="live"
    :name="`${field.name}-${id}-${index}`"
    :label="null"
    :help="true"
    :value="computedValue"
    @input="handleInput"
  />
</template>

<script>
export default {
  props: {
    value: {},
    field: {},
    id: {},
    index: {},
  },
  emits: ['input'],
  computed: {
    computedValue() {
      // if it's empty, always return null
      if (this.value === '' || this.value === false) return null

      return this.value
    },
  },
  methods: {
    handleInput(newValue) {
      if (newValue && newValue.length > 0) {
        this.$emit('input', newValue)
        return
      }
      
      // if newValue is empty, always set null
      this.$emit('input', null)
    },
  },
}
</script>
